<template>
  <section>
    <services-list :data="services" />
  </section>
</template>

<script>
import { mapState } from "vuex";
import ServicesList from "@/components/ServicesList.vue";

const global = mapState("global", ["userGessan"]);

export default {
  name: "SaneamentoHome",
  components: {
    ServicesList,
  },
  computed: {
    ...global,
    isGrupoMunicipio() {
      return !!this.userGessan?.isGrupo;
    },
    services() {
      const list = [
        {
          name: "Informe de Repasse de Regulação",
          url: "/informe-repasse-regulacao",
          icon: "library_add",
          external: false,
        },
        {
          name: "Listagem das Remunerações Regulatórias",
          url: "/listagem-remuneracoes-regulatorias",
          icon: "menu",
          external: false,
        },
        {
          name: "Parcelamento",
          url: "/parcelamento",
          icon: "fa-calculator",
          external: false,
        },
      ];

      if (this.isGrupoMunicipio) {
        list.splice(2, 0, {
          name: "Multas Administrativas",
          url: "/multas-administrativas",
          icon: "gavel",
          external: false,
        });
      }

      return [
        {
          name: "Saneamento",
          url: "/saneamento",
          external: false,
          list,
        },
      ];
    },
  },
};
</script>
